var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-success",on:{"click":function($event){return _vm.finalizeUnit()}}},[_c('i',{staticClass:"fas mr-2 fa-check"}),_vm._v("\n\tFinalizar Unidade\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }